import ModalVideoBladePattern from "./ModalVideoBladePattern";
export default ModalVideoBladePattern;
